@if (!fullPageTemplate) {
  <mat-sidenav-container class="sidenav-container">
    <mat-sidenav #drawer class="sidenav" fixedInViewport
      [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
      [mode]="(isHandset$ | async) ? 'over' : 'side'"
      [opened]="(isHandset$ | async) === false">
      <mat-toolbar class="logo-img">
        <a routerLink="/"><img class="side-logo-img" src="assets/img/logo.png" class="logo"/></a>
      </mat-toolbar>
      <mat-nav-list class="main-menu">
        @if (authService.hasPermission('users_manage', 1) || authService.hasPermission('roles_manage', 1)) {
          <a class="drop" mat-list-item (click)="toggle('users')"><mat-icon>people</mat-icon>Users <mat-icon class="right">expand_more</mat-icon></a>
        }
        @if (dropdowns.users) {
          <div class="drop-down-menu cron-drop-down">
            @if (authService.hasPermission('users_manage', 1)) {
              <a routerLinkActive="active" mat-list-item routerLink="/users"><mat-icon>people</mat-icon>Users</a>
            }
            @if (authService.hasPermission('roles_manage', 1)) {
              <a routerLinkActive="active" mat-list-item routerLink="/roles"><mat-icon>people</mat-icon>Roles</a>
            }
          </div>
        }
        @if (authService.hasPermission('brands_manage', 1)) {
          <a routerLinkActive="active" mat-list-item routerLink="/brands"><mat-icon>local_offer</mat-icon>Brands</a>
        }
        @if (authService.hasPermission('pages_manage', 1)) {
          <a routerLinkActive="active" mat-list-item routerLink="/pages"><mat-icon>article</mat-icon>Pages</a>
        }
        @if (authService.hasPermission('content_updates_category_manage', 1)) {
          <a routerLinkActive="active" mat-list-item routerLink="/content-updates-categories"><mat-icon>category</mat-icon>Content Updates Category</a>
        }
        @if (authService.hasPermission('content_updates_manage', 1)) {
          <a routerLinkActive="active" mat-list-item routerLink="/content-updates"><mat-icon>content_paste</mat-icon>Content Updates</a>
        }
        @if (authService.hasPermission('posts_manage', 1)) {
          <a routerLinkActive="active" mat-list-item routerLink="/posts"><mat-icon>article</mat-icon>Posts</a>
        }
        @if (authService.hasPermission('categories_manage', 1)) {
          <a routerLinkActive="active" mat-list-item routerLink="/categories"><mat-icon>vertical_split</mat-icon>Categories</a>
        }
        @if (authService.hasPermission('contributions_manage', 1)) {
          <a routerLinkActive="active" mat-list-item routerLink="/contributions"><mat-icon>dashboard_customize</mat-icon>Contributions</a>
        }
        @if (authService.hasPermission('users_manage', 1)) {
          <a routerLinkActive="active" mat-list-item routerLink="/users-fireworks"><mat-icon>dashboard_customize</mat-icon>User's Fireworks</a>
        }
        @if (authService.hasPermission('languages_manage', 1)) {
          <a routerLinkActive="active" mat-list-item routerLink="/language"><mat-icon>language</mat-icon>Languages</a>
        }
        @if (authService.hasPermission('countries_manage', 1)) {
          <a routerLinkActive="active" mat-list-item routerLink="/countries"><mat-icon>whatshot</mat-icon>Countries</a>
        }
        @if (authService.hasPermission('fireworks_types_manage', 1)) {
          <a routerLinkActive="active" mat-list-item routerLink="/firework-types"><mat-icon>local_fire_department</mat-icon>Firework types</a>
        }
        @if (authService.hasPermission('firmwares_manage', 1)) {
          <a class="drop" mat-list-item (click)="toggle('firmware')"><mat-icon>content_copy</mat-icon>Firmware Version <mat-icon class="right">expand_more</mat-icon></a>
        }
        @if (dropdowns.firmware) {
          <div class="drop-down-menu cron-drop-down">
            <a routerLinkActive="active" mat-list-item routerLink="/beta-firmware">IGNITE Firmware</a>
            <a routerLinkActive="active" mat-list-item routerLink="/tnt-version">HOT SHOT / IGNITE <br/>Lite Firmware</a>
          </div>
        }
        @if (authService.hasPermission('logs_manage', 1)) {
          <a class="drop" mat-list-item (click)="toggle('app_logs')"><mat-icon>content_copy</mat-icon>App Logs<mat-icon class="right">expand_more</mat-icon></a>
        }
        @if (dropdowns.app_logs) {
          <div class="drop-down-menu cron-drop-down">
            <a routerLinkActive="active" mat-list-item routerLink="/ignite-logs">Ignite Logs</a>
            <a routerLinkActive="active" mat-list-item routerLink="/pyrocast-logs">Pyrocast Logs</a>
          </div>
        }
        <a routerLinkActive="active" mat-list-item routerLink="/notifications"><mat-icon>content_copy</mat-icon> Notifications</a>
        <a routerLinkActive="active" mat-list-item routerLink="/cp-gen2-notifications"><mat-icon>content_copy</mat-icon> Cp Gen 2 Notifications</a>
        <!--<a mat-list-item *ngIf="authService.hasPermission('reset_fireworks', 1)"><mat-icon>whatshot</mat-icon>Reset fireworks</a>-->
        @if (authService.hasPermission('logs_manage', 1)) {
          <a mat-list-item routerLink="/user-logs"><mat-icon>anchor</mat-icon>User Logs</a>
        }
        <a mat-list-item (click)="openDialog()"><mat-icon>lock</mat-icon>Change password</a>
        <a mat-list-item (click)="logout($event)"><mat-icon>logout</mat-icon>Log Out</a>
      </mat-nav-list>
    </mat-sidenav>
    <mat-sidenav-content>
      <mat-toolbar color="accent">
        @if (isHandset$ | async) {
          <button
            type="button"
            aria-label="Toggle sidenav"
            mat-icon-button
            (click)="drawer.toggle()"
            >
            <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
          </button>
        }
      </mat-toolbar>
      <!-- Add Content Here -->
      <router-outlet></router-outlet>
    </mat-sidenav-content>
  </mat-sidenav-container>
}
@if (fullPageTemplate) {
  <div class="container-full">
    <router-outlet></router-outlet>
  </div>
}
